import React, { Component } from 'react';
import { Nav } from 'reactstrap';
import i18n from '../../i18next';

import SysControlSideMenuListItem from './SysControlSideMenuListItem';

class SysControlSideMenuList extends Component {

    render() {
        const controlItemsArr = [{
            name: 'restrictions',
            icon: 'restaurant_menu',
            translation: i18n.t('screens:systemControlContainer.restrictions')
        },
        {
            name: 'orders',
            icon: 'restaurant_menu',
            translation: i18n.t('screens:systemControlContainer.orders')
        },
        {
            name: 'restaurants',
            icon: 'restaurant_menu',
            translation: i18n.t('screens:systemControlContainer.restaurants')
        },
        {
            name: 'database',
            icon: '',
            translation: i18n.t('screens:systemControlContainer.database')
        }];

        const { navStyles } = styles;

        return (
            <Nav vertical style={navStyles}>
                {
                    controlItemsArr.map((item, i) => {

                        return <SysControlSideMenuListItem
                            key={`syControlSideMenuItem_${i}`}
                            item={item}
                            {...this.props} />;
                    })
                }
            </Nav>
        );
    }
}

export default SysControlSideMenuList;

const styles = {
    navStyles: {
        width: 200,
        background: '#fafafa',
        // height: '100%',
        marginRight: 24
    }
};


// WEBPACK FOOTER //
// ./src/components/systemControl/SysControlSideMenuList.js